/**
 * Keeps Product layouts links on the selected Color when jumping to a linked product.
 */
(function () {
  let lastVariant = null;

  function normalize(value) {
    return String(value || '')
      .trim()
      .toLowerCase();
  }

  function optionByIndex(variant, index) {
    const position = Number(index);
    if (!variant || !position) return '';
    if (position === 1) return variant.option1 || variant.options?.[0] || '';
    if (position === 2) return variant.option2 || variant.options?.[1] || '';
    if (position === 3) return variant.option3 || variant.options?.[2] || '';
    return '';
  }

  function parseUrlMap(link) {
    const raw = link.getAttribute('data-layout-urls');
    if (!raw) return {};
    try {
      return JSON.parse(raw) || {};
    } catch (error) {
      return {};
    }
  }

  function urlFromMap(map, color, size) {
    const colorKey = normalize(color);
    const sizeKey = normalize(size);
    if (!colorKey) return '';
    if (sizeKey && map[`${colorKey}|${sizeKey}`]) return map[`${colorKey}|${sizeKey}`];
    return map[colorKey] || '';
  }

  function readOptionFromDom(optionIndex) {
    const position = Number(optionIndex);
    if (!position) return '';

    const productInfo =
      document.querySelector('product-info[id^="MainProduct-"]') ||
      document.querySelector('product-info[data-section]');
    const variantSelects = productInfo?.querySelector('variant-selects');
    if (!variantSelects) return '';

    const fieldsets = variantSelects.querySelectorAll('fieldset');
    if (fieldsets.length >= position) {
      const checked = fieldsets[position - 1].querySelector('input[type="radio"]:checked');
      if (checked?.value) return checked.value;
    }

    const select = variantSelects.querySelector(`#Option-${productInfo.dataset.section}-${position - 1}`);
    return select?.value || '';
  }

  function currentSelection(root) {
    return {
      color:
        optionByIndex(lastVariant, root.dataset.colorOptionIndex) ||
        readOptionFromDom(root.dataset.colorOptionIndex),
      size:
        optionByIndex(lastVariant, root.dataset.sizeOptionIndex) ||
        readOptionFromDom(root.dataset.sizeOptionIndex),
    };
  }

  function syncLink(link, color, size) {
    const nextUrl = urlFromMap(parseUrlMap(link), color, size);
    if (nextUrl) link.href = nextUrl;
  }

  function syncAll() {
    document.querySelectorAll('[data-product-layouts]').forEach((root) => {
      const { color, size } = currentSelection(root);
      root.querySelectorAll('[data-product-layout-link]').forEach((link) => {
        syncLink(link, color, size);
      });
    });
  }

  function bind() {
    if (bind.bound) return;
    bind.bound = true;

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        lastVariant = event?.data?.variant || null;
        if (!lastVariant) return;
        syncAll();
      });
    }

    document.addEventListener('click', (event) => {
      const link = event.target.closest?.('[data-product-layout-link]');
      if (!link) return;
      const root = link.closest('[data-product-layouts]');
      if (!root) return;
      const { color, size } = currentSelection(root);
      syncLink(link, color, size);
    });
  }

  function init() {
    bind();
    syncAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
